module.exports = __webpack_public_path__ + "static/img/67066G_2_C_20230613_LC.d3a6b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67066G_2_C_20230613_LC.png
// module id = iquF
// module chunks = 0